<form [formGroup]="userDetailsForm" (ngSubmit)="validateAndConfirmOrder()">
  <div class="user-info-section">
    <div class="user-info-control">
      <label class="user-label" aria-label="first name"
        >{{ 'first-last-name' | translate }} <span class="alert">*</span></label
      >
      <input
        type="text"
        class="user-input"
        data-qa="user-name"
        formControlName="name"
        data-qa="name"
        aria-label="first name"
      />
      <div
        *ngIf="userDetailsForm.controls.name.errors && formSubmitted"
        class="alert-text"
        aria-label="name-error"
      >
        {{ 'name-alert' | translate }}
      </div>
    </div>
    <div class="user-info-control">
      <label class="user-label" aria-label="mobile number"
        >{{ 'mobile-number' | translate }} <span class="alert">*</span></label
      >
      <wj-phone-input
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        class="phoneNumber"
        placeholder="{{'enter-mobile'| translate}}"
        [phone]="userDetails.phone"
        data-qa="contact-number"
        aria-label="contact number"
        [submitted]="formSubmitted"
        (Formatted)="formattedPhone($event)"
      ></wj-phone-input>
      <div *ngIf="showDropdown" class="dropdown-content">
        <div class="drop-value" (click)="onSelect($event)">
          <img [src]="canadaFlag" />
        </div>
      </div>
      <div
        *ngIf="
          !this.phoneNumber.valid &&
          this.phoneNumber.international == '' &&
          formSubmitted
        "
        class="alert-text"
      >
        {{ 'contact-number-error' | translate }}
      </div>
    </div>

    <button
      type="submit"
      class="complete-btn btn-primary"
      data-qa="complete-order"
      aria-label="complete order"
      [disabled]="disableButton"
    >
      {{ 'complete-order' | translate }}
    </button>
  </div>
</form>
